import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-globe',
	templateUrl: './icon-globe.component.svg',
})
export class IconGlobeComponent {}
